<template>
  <div class="top" :style="style">
    <Animation
      :speed="animationSpeed"
      :animation="'fire'"
      mode="lottie"
      class="top__fire"
    />
    <img
      src="../../assets/img/tower/top.svg"
      width="100%"
      height="auto"
      class="top__tower"
    />
  </div>
</template>

<script>
import Animation from "../Animation";

const getMargin = tower => {
  switch (tower) {
    case 0:
      return -13.5;
    case 1:
      return -10.5;
    default:
      return -8;
  }
};

export default {
  components: { Animation },
  props: ["towerId"],
  data() {
    const margin = getMargin(this.towerId);
    return {
      style: {
        marginBottom: `calc(var(--vh, 1vh) * ${margin})`
      },
      animationSpeed: Math.random() + 0.5
    };
  }
};
</script>

<style lang="scss" scoped>
.top {
  & > * {
    position: relative;
  }

  &__fire {
    z-index: 1;
    // margin-bottom: -30.5% !important;
    margin-bottom: -12.5% !important;
  }
  &__tower {
    z-index: 0;
  }
}
</style>
